// ViewDetailsModal.tsx
import { Modal, Typography, Tag } from "antd";
import dayjs from "dayjs";

interface ViewDetailsModalProps {
  visible: boolean;
  onClose: () => void;
  user: {
    name: string;
    email: string;
    status: "Active" | "Inactive" | "Suspended";
    plan: string;
    signupDate: string;
    lastLogin: string;
  };
}

const ViewDetailsModal = ({
  visible,
  onClose,
  user,
}: ViewDetailsModalProps) => {
  const { Text } = Typography;

  if (!user) {return null;} // ← Prevent rendering if user is null

  const getStatusTag = (status: string) => {
    const color =
      status === "Suspended" ? "red" : status === "Active" ? "green" : "gray";
    return <Tag color={color}>{status}</Tag>;
  };

  return (
    <Modal title="User Details" open={visible} onCancel={onClose} footer={null} aria-label="User Details Modal">
      <p style={{ color: "gray" }}>Complete information about the user.</p>
      <p>
        <Text strong>Name:</Text> {user.name}
      </p>
      <p>
        <Text strong>Email:</Text> {user.email}
      </p>
      <p>
        <Text strong>Status:</Text> {getStatusTag(user.status)}
      </p>
      <p>
        <Text strong>Plan Type:</Text> {user.plan}
      </p>
      <p>
        <Text strong>Signup Date:</Text> {dayjs(user.signupDate).format("DD-MM-YYYY HH:mm")}
      </p>
      <p>
        <Text strong>Last Login:</Text> {user.lastLogin}
      </p>
    </Modal>
  );
};

export default ViewDetailsModal;
